<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kVH3CL/tc-custom/9781952225116.jpg?1728327053821" alt="This image is the cover for the book Screaming Room, The John Driscoll Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Screaming Room, The John Driscoll Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>A multimillion-dollar bounty brings out every vigilante in New York . . . “Chilling psychological suspense that will leave you at the edge of your seat.” —Alex Kava, <i>New York Times</i>–bestselling author of the Maggie O’Dell series</b><br/>  <br/> Tourism in New York City is under siege. Visitors to the Big Apple have become targets of a pair of vengeful twins bent on exacting punishment on total strangers to right the wrongs perpetrated against them in a hellhole they called home. Their audacious killing spree leaves men and women of all ages and ethnicities brutally murdered then scalped, their lifeless forms displayed in macabre fashion at landmarks throughout the metropolis.<br/>  <br/> NYPD Homicide Commander John W. Driscoll, along with his dedicated team of Sgt. Margaret Aligante and Det. Cedric Thomlinson, is determined to bring the pair to justice—as is a despicable grieving father whose idea of justice is at odds with morality itself. By offering a three million dollar bounty, not a cent of which he plans to part with, he’s turned the city into a get-rich-quick circus, with an overzealous mayor acting as ringmaster to please Mr. Moneypockets any way he can.<br/>  <br/> And Driscoll—who’s been assigned the case just hours after he buried his wife—must put his grief on hold and focus on shutting down the twins’ reign of terror by apprehending them before their denouement is dictated by an unscrupulous and unforgiving interloper . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas O'Callaghan
      </h2>
      
      <p class="authorDescription body article">Thomas O’Callaghan is an author of two other novels, NO ONE WILL HEAR YOUR SCREAMS and BONE THIEF, in the John Driscoll Thriller Series. Both have been translated for publication in Germany, Slovakia, Indonesia, the Czech Republic, China, and Italy.  He’s a member of both the Mystery Writers of America and the International Thriller Writers associations.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d239eb8